import { WebRestClient } from '@repo/c360-feathers-utils';
import { resources } from '@repo/c360-ra-components';

export const apiUrl = import.meta.env['VITE_API_URL'] || 'http://localhost:8000';

export const feathersClient = WebRestClient({
  url: apiUrl,
  authenticationPath: resources.adminAuthentication,
});
